import React, { Component } from "react";

class BlockingScreen extends Component {
  render() {
    return <div id="blocking-screen" />;
  }
}

export default BlockingScreen;
